import { getResolvedLanguage } from '~/components/I18n';

const GITBOOK_URL_MAP: Record<string, string> = {
  ko: 'https://dosi.gitbook.io/dosi-kor/dosi-citizen',
  // Note: ja link will be added next version of v2.0.0
  // ja: 'https://dosi-jp.landpress.line.me/dosicitizen_guidejp',
  global: 'https://dosi.gitbook.io/dosi-eng/dosi-citizen',
};

const GITBOOK_LAND_URL_MAP: Record<string, string> = {
  ko: 'https://dosi.gitbook.io/dosi-kor/dosi-citizen/undefined-5',
  global: 'https://dosi.gitbook.io/dosi-eng/dosi-citizen/dosi-land',
};

const TWITTER_URL_MAP: Record<string, string> = {
  ja: 'https://twitter.com/DOSI_JP',
  global: 'https://twitter.com/DOSI_official',
};

export const useGitbookUrl = () => GITBOOK_URL_MAP[getResolvedLanguage()] || GITBOOK_URL_MAP.global;

export const useLandGitbookUrl = () =>
  GITBOOK_LAND_URL_MAP[getResolvedLanguage()] || GITBOOK_LAND_URL_MAP.global;

export const useTwitterUrl = () => TWITTER_URL_MAP[getResolvedLanguage()] || TWITTER_URL_MAP.global;
